import axiosInstance from '@/utils/api.js'

var state = {
  dhcpPools: []
}

var getters = {
  DHCP_POOLS: (state) => {
    return state.dhcpPools
  }
}

var mutations = {
  SET_DHCP_POOLS: (state, payload) => {
    state.dhcpPools = payload
  }
}

var actions = {
  GET_DHCP_POOLS: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/dhcp_pools')
    if (result.status === 200) {
      context.commit('SET_DHCP_POOLS', result.data)
    }
  },
  CREATE_DHCP_POOLS: (context, payload) => {
    return axiosInstance.post('/inventory/dhcp_pool', payload)
  },
  UPDATE_DHCP_POOLS: (context, payload) => {
    return axiosInstance.put('/inventory/dhcp_pool', payload)
  },
  DELETE_DHCP_POOLS: (context, payload) => {
    return axiosInstance.delete('/inventory/dhcp_pool?pool_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/inventory/dhcpPools.js